module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope.has_engaged_preference === false) ? _c('alert', {
    attrs: {
      "type": "alert-color",
      "icon": "warning",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('message.labelHi')) + " " + _vm._s(_vm.$store.state.user.scope.firstname) + ", " + _vm._s(_vm.$t('message.labelUpdateCommPreferences')) + "\n    "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pointer",
    attrs: {
      "slot": "action",
      "to": {
        name: 'SettingsPreferences'
      }
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.updateText'))
    },
    slot: "action"
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2cb61b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GDPRReminder/gdpr-reminder.vue
// module id = 3838
// module chunks = 1